import { createFileRoute } from '@tanstack/react-router'

import {
  getTaxonomyOptions,
  listTaxonomyVersionsOptions,
} from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/$taxonomyId',
)({
  loader: ({ context: { queryClient }, params: { spaceId, taxonomyId } }) => {
    queryClient.ensureQueryData(
      getTaxonomyOptions({
        path: {
          spaceID: spaceId,
          taxonomyID: taxonomyId,
        },
      }),
    )

    queryClient.ensureQueryData(
      listTaxonomyVersionsOptions({
        path: {
          spaceID: spaceId,
          taxonomyID: taxonomyId,
        },
      }),
    )
  },
})
